module.exports = "/virtual-football-league/img/games-table-odds-hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/games-table-odds-hover.png
// module id = 181
// module chunks = 4